export function ensureHash(newHash: string): string {
  if (window.location.hash) {
    return window.location.href.substring(0, window.location.href.lastIndexOf(window.location.hash)) + newHash;
  }
  return window.location.hash + newHash;
}
